module.exports = __webpack_public_path__ + "img/cpany15.f108a9b7.png";